export default __webpack_public_path__ + "static/media/ts.e0cf5672.svg";